/**
 * This simple type specifies the possible modes for autosize
 */
export enum AutosizeMode {
    /** With this mode you have a fixed height on text shapes */
    FIXED_HEIGHT = "FIXED_HEIGHT",

    /** With this mode you have a fixed size on text shapes */
    FIXED_SIZE = "FIXED_SIZE",

    /** With this mode you have a fixed width on text shapes */
    FIXED_WIDTH = "FIXED_WIDTH",
}
